module.exports = __webpack_public_path__ + "img/gb9117_6_b.prt.fe9421f3.jpg";